/* @flow */
import Fieldset from 'components/Fieldset';
import * as React from 'react';
import Text from 'components/Text';
import TeacherDetail from '../entities/TeacherDetail';

import './styles/TeacherDetailView.scss';

type Props = {
  teacherDetail: TeacherDetail,
};

function TeacherDetailActivitySection(props: Props) {
  return (
    <Fieldset legend="Activity in the last 30 days" size="small">
      <div className="TeacherDetailView-usageStats">
        <div className="TeacherDetailView-usageStat">
          <Text
            className="TeacherDetailView-usageStat-header"
            color="pitch"
            size="xxxxlarge"
            weight="light">
            {props.teacherDetail.getLast30DaysAnnouncementsCount()}
          </Text>
          <Text color="thunder" size="xxsmall">
            Announcements sent
          </Text>
        </div>

        <div className="TeacherDetailView-usageStat">
          <Text
            className="TeacherDetailView-usageStat-header"
            color="pitch"
            size="xxxxlarge"
            weight="light">
            {props.teacherDetail.getLast30DaysParticipantChatCount()}
          </Text>
          <Text color="thunder" size="xxsmall">
            Chats with participants
          </Text>
        </div>
      </div>
    </Fieldset>
  );
}

export default TeacherDetailActivitySection;
